<div class="body none">

<main>
<div class="nav-home">
    <app-navbar></app-navbar>
  </div>
<app-sqanimation></app-sqanimation>
<div class="container-fluid what-eureka">
    <div class="whatis">
      <h3>VISION BEHIND</h3>
      <h1 class="eurekaheading" #eurekaHeading>EUREKA! GCC</h1>
      <p>
        Great ideas result in great undertakings, setting the stage for lasting success. Eureka! GCC fosters this vision by offering a platform where potential ideas and early-stage startups can thrive in a supportive, risk-free environment. It bridges the gap between concept and enterprise, ensuring a smooth, guided journey from inspiration to impactful business innovation.
      </p>
    </div>
  </div>


  <div class="container-fluid what-eureka">
    <div class="whatis">
      <h3>ABOUT</h3>
      <h1 class="eurekaheading" #eurekaHeading>E-Cell IIT Bombay</h1>
      <div class="whatis-content">
        <img src="https://2k21.s3.ap-south-1.amazonaws.com/E-Cell+Logo-Black+(1).png" alt="E-Cell IIT Bombay" class="whatis-image" />
      <p id="newimg">
        The Entrepreneurship Cell of IIT Bombay is Asia's largest non-profit entrepreneurship promoting body run by students. It has been active for 26 years and has impacted millions of individuals in India and abroad.
      </p>
      </div>
    </div>
  </div>
  

  <div class="container-fluid what-eureka">
    <div class="whatis">
      <h3>ABOUT</h3>
      <h1 class="eurekaheading" #eurekaHeading>Gulf Islamic Investments</h1>
      <div class="whatis-content">
        <img src="https://2k21.s3.ap-south-1.amazonaws.com/GII24Logo.png" alt="E-Cell IIT Bombay" class="whatis-image" id="gii" />
    
      <p id="newimg">
        Gulf Islamic Investments LLC (GII) is a UAE-based financial services company regulated by the Emirates Securities and Commodities Authority (ESCA). Under the leadership of a committed group of prominent shareholders and investors, GII’s team enjoys collective investment, strategic management, finance, and accounting experience. GII and its team enjoy a track record of managing $2.5 billion in assets and securing $5.5 billion in debt and in excess of $1.0 billion in equity.      </p>
      </div>
    </div>
  </div>

 
  <div class="boxy" style="padding-bottom: 0px">
    <app-footer></app-footer>
  </div>
</main>
</div>